import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './style.scss';

const handleToggleGridView = (isGrid, selection, toggleGridView) => {
  if (isGrid !== selection) {
    toggleGridView({ isGrid: selection });
  }
};

const ProjectsSwitch = ({ isGrid, projects, toggleGridView }) => (
  <div styleName="grid__switch">
    <button
      disabled={!projects.length}
      styleName={classnames('grid__switch__option', { 'is-active': isGrid })}
      onClick={() => handleToggleGridView(isGrid, true, toggleGridView)}
      data-test="grid"
    >
      <i className="icon-grid-view" />
    </button>
    <button
      disabled={!projects.length}
      styleName={classnames('grid__switch__option', { 'is-active': !isGrid })}
      onClick={() => handleToggleGridView(isGrid, false, toggleGridView)}
      data-test="list-view-button"
    >
      <i className="icon-list-view" />
    </button>
  </div>
);

ProjectsSwitch.propTypes = {
  isGrid: PropTypes.bool,
  projects: PropTypes.arrayOf(PropTypes.object),
  toggleGridView: PropTypes.func,
};

export default ProjectsSwitch;
